import { readWinHistoryList } from '@/api/bet/read';
import Header from '@/component/Header';
import { winHistoryColumns } from '@/component/bet/table/BetColumnData';
import { Tables } from '@/component/pools/table/Tables';
import { packBigNumbers } from '@/lib/BigNumbers';
import { SUCCESS } from '@/lib/common/name-space';
import { WinHistoryListType } from '@/types';
import { Box, Card, CardContent, Divider } from '@mui/material';
import { useEffect, useState } from 'react';

export default function WinHistoryList() {
  const [list, setList] = useState<WinHistoryListType[]>([]);

  useEffect(() => {
    (async () => {
      const re = await readWinHistoryList();
      if (re.status !== SUCCESS) {
        return;
      }

      const data = re.data.map((item: WinHistoryListType) => ({
        ...item,
        totalBet: packBigNumbers(item.totalBet),
        betAmount: packBigNumbers(item.betAmount),
        winAmount: packBigNumbers(item.winAmount),
        jackpotPayout: packBigNumbers(item.jackpotPayout),
        jackpotReserve: packBigNumbers(item.jackpotReserve),
        smallWinAmount: packBigNumbers(item.smallWinAmount),
        referralAmount: packBigNumbers(item.referralAmount),
        burnAmount: packBigNumbers(item.burnAmount),
      }));

      setList(data);
    })();
  }, []);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
          height: '100vh',
          maxHeight: '100vh',
        }}
      >
        <Card>
          <Header title="Win History 리스트" />
          <Divider />
          <Box mb={2} />
          <CardContent sx={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto' }}>
            {list && <Tables list={list} columns={winHistoryColumns} getRowId={(row) => row.historyId} />}
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
